/* Lumenti: slider strony głównej, kafelki ilości, polskie teksty koszyka i formularza. Zdarzenia przez delegację na document. */
(function () {
  function initHero(root) {
    if (root.dataset.nxReady) return;
    root.dataset.nxReady = '1';
    var track = root.querySelector('.nx-hero__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.nx-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.nx-hero__dot'));
    if (!track || slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark();
    }
    function mark() {
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function play() {
      stop();
      if (!reduce) timer = setInterval(function () { go(i + 1); }, 6500);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      if (n !== i) { i = n; mark(); }
    }, { passive: true });
    root.addEventListener('click', function (e) {
      var dot = e.target.closest('.nx-hero__dot');
      var arrow = e.target.closest('.nx-hero__arrow');
      if (dot) { go(dots.indexOf(dot)); play(); }
      if (arrow) { go(i + (arrow.dataset.dir === 'prev' ? -1 : 1)); play(); }
    });
    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', play);
    root.addEventListener('focusin', stop);
    mark();
    play();
  }

  function initAll() {
    document.querySelectorAll('[data-nx-hero]').forEach(initHero);
    fixTexts();
  }

  function setQty(wrap, n) {
    var scope = wrap.closest('product-form-component, form, .product-details, section') || document;
    var inputs = scope.querySelectorAll('input[name="quantity"]');
    if (!inputs.length) inputs = document.querySelectorAll('input[name="quantity"]');
    inputs.forEach(function (inp) {
      inp.value = n;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrap.querySelectorAll('.nx-qty__opt').forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.dataset.qty) === n));
    });
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.nx-qty__opt');
    if (!opt) return;
    e.preventDefault();
    setQty(opt.closest('.nx-qty'), Number(opt.dataset.qty) || 1);
  });

  /* Po zmianie wariantu przelicz ceny kafelków (ceny w groszach z JSON w bloku). */
  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-picker, .variant-picker')) return;
    setTimeout(refreshPrices, 400);
  });
  function money(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    return s.replace(',00', '') + ' zł';
  }
  function refreshPrices() {
    document.querySelectorAll('.nx-qty').forEach(function (wrap) {
      var vid = new URL(location.href).searchParams.get('variant');
      var map = {};
      try { map = JSON.parse(wrap.querySelector('script[type="application/json"]').textContent); } catch (err) { return; }
      var price = vid && map[vid] ? map[vid] : map._first;
      if (!price) return;
      wrap.querySelectorAll('.nx-qty__opt').forEach(function (b) {
        var n = Number(b.dataset.qty), off = Number(b.dataset.off) || 0;
        var total = Math.round(price * n * (100 - off) / 100);
        b.querySelector('.nx-qty__price').textContent = money(total);
        var each = b.querySelector('.nx-qty__each');
        if (each && n > 1) each.textContent = money(Math.round(total / n)) + ' / szt.';
        var save = b.querySelector('.nx-qty__save');
        if (save) save.textContent = '−' + money(price * n - total);
      });
    });
  }

  /* Polskie, prostsze teksty w koszyku i formularzu kontaktu (Horizon ma je w pliku języka). */
  var TEXTS = [
    ['Przewidywana suma', 'Razem'],
    ['Z wliczonymi cłami i podatkami. Koszt wysyłki jest obliczany przy realizacji zakupu.', 'Cena z VAT. Darmowa dostawa od 199 zł, poniżej 14,99 zł.'],
    ['Z wliczonymi cłami i podatkami. Obliczenie rabatów i wysyłki przy realizacji zakupu.', 'Cena z VAT. Darmowa dostawa od 199 zł, poniżej 14,99 zł.'],
    ['Z wliczonymi podatkami. Koszt wysyłki jest obliczany przy realizacji zakupu.', 'Cena z VAT. Darmowa dostawa od 199 zł, poniżej 14,99 zł.'],
    ['Zrealizuj zakup', 'Przejdź do kasy']
  ];
  var PLACEHOLDERS = { 'Nazwisko': 'Imię', 'Komentarz': 'W czym możemy pomóc? Jeśli pytasz o zamówienie, podaj jego numer.' };
  function fixTexts() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue.trim();
      if (!t || t.length > 140) continue;
      for (var k = 0; k < TEXTS.length; k++) {
        if (t === TEXTS[k][0]) { n.nodeValue = n.nodeValue.replace(TEXTS[k][0], TEXTS[k][1]); break; }
      }
    }
    document.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
      if (PLACEHOLDERS[el.placeholder]) el.placeholder = PLACEHOLDERS[el.placeholder];
    });
    document.querySelectorAll('label').forEach(function (el) {
      var t = el.textContent.trim();
      if (PLACEHOLDERS[t] && el.children.length === 0) el.textContent = t === 'Nazwisko' ? 'Imię' : 'Wiadomość';
    });
  }
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; fixTexts(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();